import React from "react";





const Play = () => {
  return (
    <div className="w-screen h-screen">
      <iframe
        src="https://playbook.demo.sourceoptima.com/ "
        title="Read Book"
        className="w-full h-full"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default Play;